// If roundingPriority is "auto", notation is "compact", and none of the four options are
// set, then they are set to { minimumFractionDigits: 0, maximumFractionDigits: 0,
// minimumSignificantDigits: 1, maximumSignificantDigits: 2 }, regardless of the defaults
// mentioned above, and roundingPriority is set to "morePrecision".
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#roundingpriority
const formatNumberCompactDigitDefaults = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  minimumSignificantDigits: 1,
  maximumSignificantDigits: 3,
  roundingPriority: 'morePrecision',
} as const;

export default formatNumberCompactDigitDefaults;
